// Note: first must be loaded the vendor files in `setup.typoscript`:
// EXT:car24website/Resources/Public/Vendor/jquery/jquery.min.js
// EXT:car24website/Resources/Public/Vendor/jquery/jquery-ui.min.js

import './modules/scroll';
import './modules/toggle-nav';
import './modules/in-view';
import './modules/swiper';
import './modules/accordion';
import '../components/mobile-menu/js/mobile-menu.jquery.min';

console.log('>> The app is started!');
